<template>
  <v-dialog v-model="dialog" width="1200">
    <v-card v-if="itemParam" height="80vh">
      <v-toolbar flat dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title> Informações Item VO </v-toolbar-title>
      </v-toolbar>
      <v-tabs vertical>
        <v-tab class="pa-0" style="min-width: 0px; height: 0px" />
        <v-tab> CEST </v-tab>
        <v-tab> NESH </v-tab>
        <v-tab> ICMS </v-tab>
        <v-tab> PIS COFINS </v-tab>
        <v-tab> IPI </v-tab>

        <v-tab-item>
          <v-container fill-height>
            <v-layout align-center>
              <p>Selecione algum item para visualizar a entidade correspondente</p>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <TelaDeCEST :busca-param="getDescricao(itemVO.cest)" />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <TelaDeNESH :busca-param="getDescricao(itemVO.nesh)" />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <TelaDeICMS :busca-param="getDescricao(itemVO.icms)" />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <TelaDePISCOFINS :busca-param="getDescricao(itemVO.pisCofins)" />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <TelaDeIPI :busca-param="getDescricao(itemVO.ipi)" />
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-dialog>
</template>

<script>
import ItemVO from '@/models/itemvo'
import TelaDeCEST from '@/views/cadastros/cest/TelaDeCEST'
import TelaDeNESH from '@/views/cadastros/nesh/TelaDeNESH'
import TelaDeICMS from '@/views/cadastros/icms/TelaDeICMS'
import TelaDePISCOFINS from '@/views/cadastros/piscofins/TelaDePISCOFINS'
import TelaDeIPI from '@/views/cadastros/ipi/TelaDeIPI.vue'

export default {
  components: {
    TelaDeCEST,
    TelaDeNESH,
    TelaDeICMS,
    TelaDePISCOFINS,
    TelaDeIPI
  },
  props: ['showDialog', 'itemParam'],

  data: () => ({
    dialog: false,
    itemVO: new ItemVO()
  }),

  watch: {
    showDialog() {
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },

    dialog() {
      return this.dialog ? true : this.fecharDialog()
    },

    itemParam() {
      return this.itemParam ? (this.itemVO = this.itemParam) : ''
    }
  },

  methods: {
    fecharDialog() {
      this.$emit('update:itemParam', null)
      this.$emit('update:showDialog', false)
    },

    getDescricao(item) {
      return item?.descricao
    }

    /*async loadCESTs() {
      this.loading = true
      this.cests = await CESTService.getAll()
      this.loading = false
    },

    async loadNESHs() {
      this.loading = true
      this.neshs = await NESHService.getAll()
      this.loading = false
    },

    async loadICMSs() {
      this.loading = true
      this.icmss = await ICMSService.getAll()
      this.loading = false
    },

    async loadPISCOFINSs() {
      this.loading = true
      this.piscofinss = await PISCOFINSService.getAll()
      this.loading = false
    },

    changeTab(index) {
      if (index === 1) this.loadCESTs()
      else if (index === 2) this.loadNESHs()
      else if (index === 3) this.loadICMSs()
      else if (index === 4) this.loadPISCOFINSs()
    }*/
  }
}
</script>
